import { useCallback, useState } from 'react';

import { ErrorInDialog } from '@/components/shared/components/ErrorBoundary/types/ErrorInDialog';
import { useUserContext } from '@/contexts/UserContext/UserContext';

export const useErrorBoundary = () => {
  const { updateUserContext } = useUserContext();

  const [, setError] = useState();

  const throwError = useCallback(
    (e) => {
      setError(() => {
        throw e;
      });
    },
    [setError],
  );

  const throwErrorInAlert = useCallback((tId: string, retryFn?: () => void) => {
    updateUserContext({ alertNotification: { tId, retryFn: retryFn } });
  }, []);

  const throwErrorInDialog = useCallback(
    (e, retryFn?: () => Promise<void> | void) => {
      setError(() => {
        throw new ErrorInDialog(e, retryFn);
      });
    },
    [setError],
  );

  const tryCatchAndRetryInDialog = async (tryBlock: () => Promise<void> | void) => {
    try {
      await tryBlock();
    } catch (error) {
      throwErrorInDialog(error, tryBlock);
    }
  };

  return { throwError, throwErrorInAlert, throwErrorInDialog, tryCatchAndRetryInDialog };
};
